
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    Snackbar,
    Theme,
    Typography,
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';

import QRCode  from 'qrcode.react';
import { resolveUrl } from '../../api';
import copy from 'copy-to-clipboard';
import MuiAlert from '@mui/material/Alert';


export default function ShareUrl ({name,show,setShow}) {

    const [alertMessage, setAlertMessage] = React.useState<Object>({
        open1: false,
        vertical: 'top',
        horizontal: 'center',
        type: 'success',
        message: 'xxx',
        activeTime: 2000,
      });
      const {open, type, message, vertical, horizontal, activeTime} = alertMessage;

    return (
        <Dialog maxWidth="md" fullWidth open={show} onClose={() => setShow(false)}>
        <DialogTitle>
           <Box style={{fontSize:'17px',textAlign:'center'}}>{name}</Box> 
                
                <IconButton
                    aria-label="close"
                    onClick={()=>setShow(false)}
                    style={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                    size="large">
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <Divider></Divider>
        <DialogContent style={{minHeight: '200px',paddingLeft:'27px'}}>
           
            <Box style={{display:'flex',flexDirection:'column',alignItems:"center"}}>
                <Box>
                    <QRCode id='qrCode' style={{width:'100px', height:'100px'}}
                        value={document.location.href}  //value参数为生成二维码的链接
                        size={100} //二维码的宽高尺寸
                        fgColor="#000000"  //二维码的颜色
                    />
                </Box>
            <Box style={{display:'flex',flexDirection:'column',justifyContent:'space-around',alignItems:'center',padding:'10px'}}>      
                <Box style={{padding:'10px'}}>
                    {'下载二维码或者手机扫一扫后分享给他人'}
                </Box>
                <Box style={{padding:'10px'}}>
                    <Button variant='contained' color='primary' style={{background:'red'}}
                    onClick={() => {
                    const canvasImg = document.getElementById('qrCode'); // 获取canvas类型的二维码
                    const img = new Image();
                    img.src = canvasImg.toDataURL('image/png'); // 将canvas对象转换为图片的data url
                    const link = document.createElement('a');
                    link.href = img.src;
                    link.download='二维码';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    }}
                >
                    {'下载二维码'}
                </Button>
                </Box>
                    </Box>
              
            </Box>
            <Box style={{display:'flex',paddingTop:'20px',paddingBottom:'30px'}}>
                    <Box style={{background:'#e7e7e773',padding:'12px 5px',border:'1px solid rgba(231, 231, 231, 0.45)',width:'100%',textOverflow:'ellipsis',overflow:'hidden',wordBreak:'break-all',whiteSpace:'nowrap'}}>{document.location.href}</Box>
                    <Box onClick={()=>{
                        copy(document.location.href);
                        setAlertMessage({...alertMessage, open: true, type: 'success', message: '已复制到剪贴板'});

                    }} style={{fontSize:'16px',padding:'12px 5px',background:'red',color:'white',width:'100px',textAlign:'center',cursor:'pointer'}}>{"复制链接"}</Box> 
                </Box>
        </DialogContent>
        <Snackbar anchorOrigin={{ vertical, horizontal}} open={open} onClose={()=>{setAlertMessage({...alertMessage, open: false})}} autoHideDuration={activeTime}>
            <MuiAlert elevation={8} variant="filled" severity={type} onClose={()=>{setAlertMessage({...alertMessage, open: false})}}>{message}</MuiAlert>
          </Snackbar>
      </Dialog>
    );

}